import React, { useState } from "react";
import { Wallet, ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "./ui/button";
import { financements } from "../mock";

export default function Financements() {
  const [tabbedStatus, setTabbedStatus] = useState("salarie");

  return (
    <section id="financements" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="blob w-[500px] h-[500px] bg-[#e8a04d]/15 -bottom-40 -left-32" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-widest text-[#2c7a80] font-semibold">Financements</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-[#0e3a3f] leading-[1.05] mt-3 title-underline">
              Financer votre formation<br />sans se ruiner.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#0e3a3f]/75 leading-relaxed">
              De multiples dispositifs existent pour financer tout ou partie du CAP AEPE.
              Notre équipe vous accompagne dans le montage administratif de votre dossier.
            </p>
          </div>
        </div>

        {/* Status selector */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
          <span className="text-xs uppercase tracking-widest text-[#0e3a3f]/50 font-semibold">Votre situation :</span>
          <div className="inline-flex bg-white border border-[#e6ded0] rounded-full p-1">
            {[
              { id: "salarie", label: "Salarié" },
              { id: "demandeur", label: "Demandeur d'emploi" },
              { id: "jeune", label: "Jeune - de 26 ans" },
            ].map((s) => (
              <button
                key={s.id}
                onClick={() => setTabbedStatus(s.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  tabbedStatus === s.id
                    ? "bg-[#2c7a80] text-white"
                    : "text-[#0e3a3f]/70 hover:text-[#0e3a3f]"
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>

        {/* Financement options */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
          {financements.map((f) => (
            <div
              key={f.title}
              className="group bg-white border border-[#e6ded0] rounded-2xl p-6 hover-lift relative overflow-hidden"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-11 h-11 rounded-lg bg-[#e8a04d]/15 flex items-center justify-center">
                  <Wallet className="w-5 h-5 text-[#e8a04d]" />
                </div>
                <span className="text-[10px] uppercase tracking-widest text-[#2c7a80] font-semibold bg-[#2c7a80]/10 px-2.5 py-1 rounded-full">
                  {f.tag}
                </span>
              </div>
              <h4 className="font-display text-lg font-medium text-[#0e3a3f] mb-2">{f.title}</h4>
              <p className="text-sm text-[#0e3a3f]/70 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        {/* CTA banner */}
        <div className="relative rounded-3xl bg-gradient-to-br from-[#0e3a3f] to-[#1a5459] p-8 md:p-12 overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#e8a04d]/20 blur-3xl" />
          <div className="relative grid md:grid-cols-3 items-center gap-6">
            <div className="md:col-span-2">
              <h3 className="font-display text-2xl md:text-3xl font-medium text-white mb-3 leading-tight">
                Besoin d'un devis personnalisé ?
              </h3>
              <p className="text-white/70 leading-relaxed">
                Nos conseillers analysent votre situation et vous proposent le montage financier le plus avantageux. Étude sans engagement.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row md:justify-end gap-3">
              <Button
                asChild
                className="bg-[#e8a04d] hover:bg-[#d68a3a] text-white rounded-full h-12 px-6 font-semibold group"
              >
                <a href="#contact">
                  Demander un devis
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-white/25 text-white hover:bg-white/10 hover:text-white bg-transparent rounded-full h-12 px-6"
              >
                <a href="tel:0493620029">
                  <PhoneCall className="w-4 h-4 mr-2" />
                  04.93.62.00.29
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
